import { render, staticRenderFns } from "./index.vue?vue&type=template&id=32d38b3a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=32d38b3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d38b3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32d38b3a')) {
      api.createRecord('32d38b3a', component.options)
    } else {
      api.reload('32d38b3a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=32d38b3a&scoped=true&", function () {
      api.rerender('32d38b3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/reports/documents/components/table/index.vue"
export default component.exports